import { BigNumber } from 'allstake-sdk';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ArrowDownImg } from '@/assets';
import GalleryCards, { CoinList } from '@/components/gallery-card';
import { HeroContainer, HeroTitle, HeroValue } from '@/components/hero';
import MeshedRestakingForm from '@/components/meshed-restaking-form';
import AssetCollapseContext from '@/context/AssetCollapseContext';
import GalleryCardsContext from '@/context/GalleryCardsContext';
import useQuery from '@/hooks/useQuery';
import { extractToTokenNameByName, isChainNativeToken } from '@/utils/regex';
import { cn } from '@/utils/styles';
import toLocaleString from '@/utils/toLocaleString';

const { useGalleryCardsTracked } = GalleryCardsContext;
const { useAssetCollapseTracked } = AssetCollapseContext;

function Restake() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [galleryCards] = useGalleryCardsTracked();
  const [assetCollapse] = useAssetCollapseTracked();

  const query = useQuery();
  const symbol = query.get('symbol');
  const tab = query.get('tab');

  const sumValue = useMemo(() => {
    if (galleryCards[0] && galleryCards[0].valueInUsdRaw === undefined) {
      return '-';
    }
    return galleryCards.reduce(
      (prev, cur) => (cur.valueInUsdRaw ?? BigNumber(0)).plus(prev),
      BigNumber(0),
    );
  }, [galleryCards]);

  useEffect(() => {
    if (symbol && isChainNativeToken(symbol) && tab === 'unstake') {
      navigate(`/?symbol=${extractToTokenNameByName(symbol)}&tab=unstake`);
    }
  }, [symbol, tab, navigate]);

  return (
    <>
      <HeroContainer>
        <HeroTitle>{t('restake.tvl')}</HeroTitle>
        <HeroValue>${sumValue === '-' ? '-' : toLocaleString(sumValue.toFixed(), 0)}</HeroValue>
      </HeroContainer>
      {assetCollapse && <CoinList />}
      <GalleryCards className={cn(!assetCollapse ? 'scale-100' : 'scale-0')} />
      <ViewDetails />
      <MeshedRestakingForm />
    </>
  );
}

const ViewDetails = () => {
  const { t } = useTranslation();
  const [assetCollapse, setAssetCollapse] = useAssetCollapseTracked();
  return (
    <div
      className={cn(
        'flex gap-1 justify-center items-center',
        'text-[#FFFFFF99] cursor-pointer select-none duration-300',
        !assetCollapse ? 'mt-[190px] md:mt-[300px]' : 'mt-[80px] md:mt-[90px]',
      )}
      onClick={() => setAssetCollapse(!assetCollapse)}
    >
      {assetCollapse && <p>{t('restake.viewDetails')}</p>}
      {!assetCollapse && <p>{t('restake.showLess')}</p>}
      <img className={cn('w-5 h-5', !assetCollapse && 'rotate-180')} src={ArrowDownImg} />
    </div>
  );
};

export default Restake;
